/* HIG-146: shared Info-Popups controller.
 * Open a popup from anywhere: an element with [data-hp-popup="versand|rueckgabe|garantie|zahlung"].
 * Click-to-open; close via [data-hp-popup-close], backdrop click or ESC. Uses event
 * delegation so triggers inside dynamically-rendered DOM (cart drawer, PDP re-renders)
 * work without re-binding. */
(function () {
  if (window.__hpPopupsInstalled) return;
  window.__hpPopupsInstalled = true;

  var root, backdrop, openKey = null, lastTrigger = null;

  function els() {
    root = document.querySelector('[data-hp-popups]');
    backdrop = root && root.querySelector('[data-hp-popup-backdrop]');
    return !!root;
  }
  function panel(key) {
    return root && root.querySelector('[data-hp-popup-panel="' + key + '"]');
  }

  function open(key, trigger) {
    if (!els()) return;
    var p = panel(key);
    if (!p) return;
    if (openKey && openKey !== key) close(true); // swap without flicker
    lastTrigger = trigger || null;
    backdrop.hidden = false;
    p.hidden = false;
    // force reflow so the transition runs
    void p.offsetWidth;
    backdrop.classList.add('is-open');
    p.classList.add('is-open');
    document.body.classList.add('hp-popup-open');
    openKey = key;
    // Focus the card (not the close button) so we don't show a focus ring on the X.
    var card = p.querySelector('.hp-popup__card');
    if (card) { try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); } }
  }

  function close(immediate) {
    if (!openKey || !els()) return;
    var p = panel(openKey);
    backdrop.classList.remove('is-open');
    if (p) p.classList.remove('is-open');
    document.body.classList.remove('hp-popup-open');
    var prevKey = openKey;
    openKey = null;
    var finish = function () {
      if (backdrop && !openKey) backdrop.hidden = true;
      var pp = panel(prevKey);
      if (pp && !pp.classList.contains('is-open')) pp.hidden = true;
    };
    if (immediate) { finish(); } else { setTimeout(finish, 220); }
    if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
    lastTrigger = null;
  }

  // Delegated open
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-hp-popup]');
    if (t) {
      ev.preventDefault();
      open(t.getAttribute('data-hp-popup'), t);
      return;
    }
    if (openKey) {
      if (ev.target.closest('[data-hp-popup-close]')) { ev.preventDefault(); close(); return; }
      if (ev.target.hasAttribute && ev.target.hasAttribute('data-hp-popup-backdrop')) { close(); return; }
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && openKey) close();
  });

  // expose a tiny API (e.g. for programmatic opens)
  window.HPPopups = { open: open, close: close };
})();
